'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiKeyboard = function TiKeyboard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 21.7h11.7v3.3h-11.7z m-5 0h3.4v3.3h-3.4z m0-6.7h3.4v1.7h-3.4z m5 5v-1.7h-5v1.7h3.4z m0-5h1.7v1.7h-1.7z m1.7 3.3h1.7v1.7h-1.7z m1.7-3.3h1.6v1.7h-1.6z m1.6 3.3h1.7v1.7h-1.7z m1.7-3.3h1.7v1.7h-1.7z m1.7 3.3h1.6v1.7h-1.6z m1.6-3.3h1.7v1.7h-1.7z m1.7 3.3h1.7v1.7h-1.7z m1.7-3.3h1.6v1.7h-1.6z m1.6 5h3.4v-5h-1.7v3.3h-1.7z m1.7 1.7h-1.7v1.6h-1.6v1.7h5v-1.7h-1.7z m3.3-11.7h-26.6c-1.9 0-3.4 1.5-3.4 3.3v13.4c0 1.8 1.5 3.3 3.4 3.3h26.6c1.9 0 3.4-1.5 3.4-3.3v-13.4c0-1.8-1.5-3.3-3.4-3.3z m0 16.7h-26.6v-13.4h26.6v13.4z' })
        )
    );
};

exports.default = TiKeyboard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/keyboard.js
// module id = 3636
// module chunks = 0